import { NavLink, Outlet } from "react-router-dom";
import StaticPageHeaders from "../../../../Components/StaticPageHeaders";
import "./index.css";
import { useLogout } from "../../../../APIContext/UseLogout";
import Swal from "sweetalert2";

const Detail = () => {
  const handleLogout = useLogout();

  const handleLogoutConfirm = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from your account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
    }).then((result) => {
      if (result.isConfirmed) {
        handleLogout();
      }
    });
  };

  return (
    <>
      <StaticPageHeaders title="Your Profile" />

      <div className="profile-section-container">
        {/* Sidebar */}
        <div
          style={{ filter: "brightness(1.2)" }}
          className="profile-sidebar bg-custom"
        >
          <NavLink
            to="/profile"
            end
            className={({ isActive }) =>
              `profile-sidebar-btn ${isActive ? "active" : ""}`
            }
          >
            <span className="text-clip">Personal Details</span>
          </NavLink>

          <NavLink
            to="/profile/players"
            className={({ isActive }) =>
              `profile-sidebar-btn ${isActive ? "active" : ""}`
            }
          >
            <span className="text-clip">My Players</span>
          </NavLink>

          <NavLink
            to="/profile/billing"
            className={({ isActive }) =>
              `profile-sidebar-btn ${isActive ? "active" : ""}`
            }
          >
            <span className="text-clip">Payments & Billings</span>
          </NavLink>

          <NavLink
            to="/profile/payment-methods"
            className={({ isActive }) =>
              `profile-sidebar-btn ${isActive ? "active" : ""}`
            }
          >
            <span className="text-clip">Payment Methods</span>
          </NavLink>

          <NavLink
            to="/profile/my-summer-camp"
            className={({ isActive }) =>
              `profile-sidebar-btn ${isActive ? "active" : ""}`
            }
          >
            <span className="text-clip">My Summer Camp</span>
          </NavLink>

          <NavLink
            to="/profile/packages"
            className={({ isActive }) =>
              `profile-sidebar-btn ${isActive ? "active" : ""}`
            }
          >
            <span className="text-clip">My Packages</span>
          </NavLink>
          <NavLink
            to="/profile/my-sessions"
            className={({ isActive }) =>
              `profile-sidebar-btn ${isActive ? "active" : ""}`
            }
          >
            <span className="text-clip">My Sessions</span>
          </NavLink>
          <NavLink
            to="/profile/notifications"
            className={({ isActive }) =>
              `profile-sidebar-btn ${isActive ? "active" : ""}`
            }
          >
            <span className="text-clip">Notifications</span>
          </NavLink>

          <NavLink
            to="/profile/password"
            className={({ isActive }) =>
              `profile-sidebar-btn ${isActive ? "active" : ""}`
            }
          >
            <span className="text-clip">Change Password</span>
          </NavLink>

          <button className="profile-sidebar-btn" onClick={handleLogoutConfirm}>
            <span className="text-clip">Log Out</span>
          </button>
        </div>

        {/* Content Area */}
        <Outlet />
      </div>
    </>
  );
};

export default Detail;
